<md-dialog>
	<div md-dialog-header>
		<md-icon class="survey-dialog__icon" icon="untitled-ui/media/lightbulb-02"></md-icon>
		<span class="md-text-lg-semibold">{{ survey().surveyName }}</span>
	</div>

	@if (survey().description) {
		<p class="survey-dialog__description">{{ survey().description }}</p>
	}

	@if (loading()) {
		<lb-loader class="survey-dialog__loading"></lb-loader>
	} @else if (loadError()) {
		<div class="survey-dialog__error">
			<md-icon icon="untitled-ui/general/alert-circle"></md-icon>
			<span class="md-text-sm-regular">Failed to load survey. Please try again.</span>
			<button md-button (click)="retry()">Retry</button>
		</div>
	} @else if (form(); as form) {
		<div class="survey-dialog__questions" [formGroup]="form">
			@for (question of questions(); track question.surveyQuestionID) {
				<div class="survey-question" [class.survey-question--invalid]="isInvalid(question.surveyQuestionID)">
					<p class="survey-question__text">
						{{ question.questionText }}
						@if (question.isOptional) {
							<span class="survey-question__optional md-text-xs-regular">(optional)</span>
						}
					</p>

					@switch (question.questionType) {
						@case (5) {
							<!-- CourseObjectives: one rating per objective in the enrollment's planned curriculum -->
							<div class="survey-question__objectives">
								@for (row of objectiveRowsFor(question.surveyQuestionID); track row.courseObjectiveID) {
									<div class="objective-row" [class.objective-row--invalid]="isInvalid(question.surveyQuestionID, row.courseObjectiveID)">
										<span class="objective-row__text md-text-sm-regular">{{ row.text }}</span>
										<lb-emoji-scale
											[scaleSize]="5"
											[value]="getControl(question.surveyQuestionID, row.courseObjectiveID).value"
											[readonly]="readonly()"
											(valueChange)="onEmojiChange(question.surveyQuestionID, $event, row.courseObjectiveID)"
										></lb-emoji-scale>
									</div>
								}
							</div>
						}
						@case (3) {
							<!-- EmojiScale -->
							<lb-emoji-scale
								[scaleSize]="question.emojiScaleSize ?? 5"
								[value]="getControl(question.surveyQuestionID).value"
								[readonly]="readonly()"
								(valueChange)="onEmojiChange(question.surveyQuestionID, $event)"
							></lb-emoji-scale>
						}
						@case (4) {
							<!-- MultipleChoice -->
							<div class="survey-question__options">
								@for (option of question.options; track option.optionID) {
									<label class="mc-option">
										<input type="radio" md-form-input [formControl]="getControl(question.surveyQuestionID)" [value]="option.optionText" />
										<span>{{ option.optionText }}</span>
									</label>
								}
							</div>
						}
						@case (2) {
							<!-- Numeric -->
							<input
								md-form-input
								class="survey-question__numeric"
								type="number"
								[min]="question.minValue ?? null"
								[max]="question.maxValue ?? null"
								[formControl]="getControl(question.surveyQuestionID)"
							/>
						}
						@default {
							<!-- Text -->
							<textarea
								md-form-input
								class="survey-question__text-input"
								rows="3"
								[formControl]="getControl(question.surveyQuestionID)"
							></textarea>
						}
					}

					@if (isInvalid(question.surveyQuestionID)) {
						<span class="survey-question__error md-text-xs-regular">This field is required</span>
					}
				</div>
			}
		</div>
	}

	@if (!readonly()) {
		<div md-dialog-footer>
			<button md-button-brand data-analytics="survey-submit" [disabled]="!allAnswered() || submitting()" (click)="submit()">
				@if (submitting()) {
					<lb-loader size="small"></lb-loader>
				} @else {
					Submit
				}
			</button>
		</div>
	}
</md-dialog>
